import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import result from 'lodash/result';

function getCoordinateBounds(seats, scale) {
  return {
    minX: result(minBy(seats, seat => seat.xpos), 'xpos') * scale,
    maxX: result(maxBy(seats, seat => seat.xpos), 'xpos') * scale,
    minY: result(minBy(seats, seat => seat.ypos), 'ypos') * scale,
    maxY: result(maxBy(seats, seat => seat.ypos), 'ypos') * scale
  };
}

function createSeatElement(seatProps, svgNS) {
  let size = 10;
  let circleEl = document.createElementNS(svgNS, 'circle');
  circleEl.setAttribute('cx', seatProps.xpos);
  circleEl.setAttribute('cy', seatProps.ypos);
  circleEl.setAttribute('id', seatProps.id);
  circleEl.setAttribute('r', size);
  return circleEl;
}

function createDisplayLetterElement(seatProps, svgNS) {
  let size = 20;
  let textEl = document.createElementNS(svgNS, 'text');
  textEl.setAttribute('class', 'syos-display-letter');
  textEl.setAttribute('font-size', size);
  textEl.setAttribute('x', seatProps.xpos);
  textEl.setAttribute('y', seatProps.ypos + size / 2);
  textEl.textContent = seatProps.letter.toUpperCase();
  return textEl;
}

function createGroup(group, svgNS, scale) {
  let g = document.createElementNS(svgNS, 'g');

  group.seats.forEach(function(seat) {
    let seatProps = {
      xpos: seat.xpos * scale,
      ypos: seat.ypos * scale
    };

    /**
     * *Should* be able to use is_seat, but in testing it always returns false.
     * Instead check for seat_num, seat_row and screen_no -
     * if these are set then assume it is an actual seat.
     */
    if (seat.seat_num && seat.seat_row && seat.screen_no) {
      seatProps.id = `seat-${seat.seat_num}-${seat.seat_row}-${seat.screen_no}`;
      let seatEl = createSeatElement(seatProps, svgNS);
      g.appendChild(seatEl);

      /**
       * If display_letter is defined then this is a letter
       * e.g., row letter.
       */
    } else if (seat.display_letter) {
      seatProps.letter = seat.display_letter;
      let letterEl = createDisplayLetterElement(seatProps, svgNS);
      g.appendChild(letterEl);
    }
  });

  g.setAttribute('id', `syos-screen-${group.screen_no}`);
  g.setAttribute('class', 'syos-screen');
  return g;
}

function generateSeatMap(seatData) {
  let scale = 40;
  let buffer = 30;
  let bounds = getCoordinateBounds(seatData, scale);
  let offset = {
    x: `-${bounds.minX - buffer}`,
    y: `-${bounds.minY - buffer}`
  };

  let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', `0 0 ${bounds.maxX} ${bounds.maxY}`);

  let svgNS = svg.namespaceURI;
  let seatmap = document.createElementNS(svgNS, 'g');

  seatmap.setAttribute('id', 'seatmap');
  seatmap.setAttribute('transform', `translate(${offset.x}, ${offset.y})`);

  let groupedSeats = map(groupBy(seatData, 'screen_no'), function(seats, key) {
    return {
      screen_no: key,
      seats: seats
    };
  });

  groupedSeats.forEach(function(group) {
    let g = createGroup(group, svgNS, scale);
    seatmap.appendChild(g);
  });

  svg.appendChild(seatmap);

  /**
   * Chrome, Safari, Firefox support outerHTML on SVG node
   * IE doesn't (yet). Serialise XML document if not supported.
   */
  let svgHTML;
  if (svg.outerHTML) {
    svgHTML = svg.outerHTML;
  } else {
    let serializer = new XMLSerializer();
    svgHTML = serializer.serializeToString(svg);
  }

  return svgHTML;
}

export default generateSeatMap;



// WEBPACK FOOTER //
// ./src/javascripts/lib/seatmaps/generateSeatMap.js